  //  icons
import {
  FiYoutube,
  FiInstagram,
  FiGithub,
  FiDribbble,
  FiLayout,
  FiSettings,
  FiPenTool,
  FiTag,
  FiMail,
  FiMapPin,
  FiPhoneCall
} from 'react-icons/fi';
import {BsLinkedin} from "react-icons/bs"

// companies icons
import FreelancerBrandIcon from './assets/img/brands/freelancer.png';
import UpworkBrandIcon from './assets/img/brands/upwork.png';
import FiverBrandIcon from './assets/img/brands/fiverr.png';
import BehanceBrandIcon from './assets/img/brands/behance.png';
import DribbbleBrandIcon from './assets/img/brands/dribbble.png';

import Project9 from './assets/img/projects/beauty.png';
import Project8 from './assets/img/projects/youtube.png';
import Project10 from './assets/img/projects/nutrimeter.png';
import Project11 from './assets/img/projects/wrike1.png';
import Project1 from './assets/img/projects/Axen.png';
// skills images
import SkillImg1 from './assets/img/skills/html5.png';
import SkillImg2 from './assets/img/skills/css3.png';
import SkillImg3 from './assets/img/skills/js.png';
import SkillImg4 from './assets/img/skills/reactjs.png';
// import SkillImg5 from './assets/img/skills/nextjs.png';
import SkillImg6 from './assets/img/skills/nodejs.png';
import SkillImg7 from './assets/img/skills/git.png';
import SkillImg8 from './assets/img/skills/redux.png';
import SkillImg9 from './assets/img/skills/mongo.png';
import SkillImg10 from './assets/img/skills/material.png';
import SkillImg11 from './assets/img/skills/chakra.png';


// testimonial images
import TestiImage1 from './assets/img/testimonials/testimonial-1.webp';
import TestiImage2 from './assets/img/testimonials/testimonial-2.webp';
import TestiImage3 from './assets/img/testimonials/testimonial-3.webp';

// navigation
export const navigation = [
  {
    name: 'home',
    href: 'home',
  },
  {
    name: 'about',
    href: 'about',
  },
  {
    name: 'portfolio',
    href: 'portfolio',
  },
  {
    name: 'services',
    href: 'services',
  },
  {
    name: 'contact',
    href: 'contact',
  }
];

// social
export const social = [
  {
    icon: <FiGithub />,
    href: 'https://github.com/Ghanishtkhurana',
  },
  {
    icon: <BsLinkedin />,
    href: 'https://www.linkedin.com/in/ghanisht-khurana-355b691b0/',
  },
];

// companies
export const brands = [
  {
    img: FreelancerBrandIcon,
    href: '',
  },
  {
    img: UpworkBrandIcon,
    href: '',
  },
  {
    img: FiverBrandIcon,
    href: '',
  },
  {
    img: BehanceBrandIcon,
    href: '',
  },
  {
    img: DribbbleBrandIcon,
    href: '',
  },
];

// projects
export const projectsData = [
  
  {
    id: '21',
    image: Project1,
    name: 'Axen',
    techStack : "React, Chakra-UI , Mongoose , MongoDB , NodeJS , Express JS ",
    path :"https://axen1.vercel.app/",
    gitCode : "https://github.com/Ghanishtkhurana/Axen",
    proDesc : "This was an Individual Project. In this website I created Axen E-commerce website - where we can place our orders"

  },
  {
    id: '2',
    image: Project8,
    name: 'Youtube',
    techStack : "React, Chakra-UI",
    path :"https://mine-youtube.vercel.app/",
    gitCode : "https://github.com/Ghanishtkhurana/mine-youtube",
    proDesc : "This was an Individual Project. In this website I created Mini - Youtube with Search Functionality"

  },
  {
    id: '3',
    image: Project10,
    name: 'Nutrimeter',
    techStack : "React, Chakra-UI,Mongo Db,Express JS",
    path :"https://nutrimeter.vercel.app/",
    gitCode : "https://github.com/harshu878/nutrimeter",
    proDesc : "This was a collaborative project built by team of 5 members in 5 days.My work was to create Support page,help page and plan page"

  },
  {
    id: '1',
    image: Project9,
    name: 'Beauty Bebo',
    techStack : "React, Chakra-UI",
    path: "https://rct-wev-3ab4.vercel.app/",
    gitCode : "https://github.com/Ghanishtkhurana/Rct_wev",
    proDesc : "This was an Individual Project. In this website I created the clone of Beauty Bebo which is a E-commerce websites for buying Beauty and Cosmetic Products"
  },
  {
    id: '4',
    image: Project11,
    name: 'Wrike',
    techStack : "HTML,CSS,JavaScript",
    path :"https://polite-lamington-b88a9f.netlify.app/",
    gitCode : "https://github.com/vishwajeethaldar/naive-alarm-6576",
    proDesc : "This was a collaborative project built by team of 5 members in 5 days.My work was to create whole solution section"

  },
  // {
  //   id: '3',
  //   image: Project3,
  //   name: 'project name 3',
  //   category: 'UI/UX design',
  // },
  // {
  //   id: '4',
  //   image: Project4,
  //   name: 'project name 4',
  //   category: 'branding',
  // },
  // {
  //   id: '5',
  //   image: Project5,
  //   name: 'project name 5',
  //   category: 'web development',
  // },
  // {
  //   id: '6',
  //   image: Project6,
  //   name: 'project name 6',
  //   category: 'web development',
  // },
];

// projects
export const projectsNav = [
  {
    name: 'all',
  },
  // {
  //   name: 'UI/UX Design',
  // },
  // {
  //   name: 'web development',
  // },
  // {
  //   name: 'branding',
  // },
];

// skill
export const skills = [
  {
    image: SkillImg1,
  },
  {
    image: SkillImg2,
  },
  {
    image: SkillImg3,
  },
  {
    image: SkillImg4,
  },
  // {
  //   image: SkillImg5,
  // },
  {
    image: SkillImg6,
  },
  {
    image: SkillImg7,
  },
  {
    image: SkillImg8,
  },
  {
    image: SkillImg9,
  },
  {
    image: SkillImg10,
  },
  {
    image: SkillImg11,
  },
];

// services
export const services = [
  {
    icon: <FiLayout />,
    name: 'Web Design',
    description:
      'I have done web designing in many projects. i design web pages with responsiveness.',
  },
  {
    icon: <FiSettings />,
    name: 'Web Development',
    description:
      'I have developed  many projects using MERN..',
  },
  {
    icon: <FiPenTool />,
    name: 'Frontend',
    description:
      'I have a great experience in Frontend as well. I really enjoy in designing a beautiful UI.',
  },
  {
    icon: <FiTag />,
    name: 'Backend',
    description:
      "I have also worked upon some backend project & created many APIs",
  },
];

// testimonials
export const testimonials = [
  {
    authorImg: TestiImage1,
    authorText:
      'Love the simplicity of the service and the prompt customer support. We can’t imagine working without it.',
    authorName: 'Olivia Doe',
    authorPosition: 'Head of Design, Google',
  },
  {
    authorImg: TestiImage2,
    authorText:
      'Love the simplicity of the service and the prompt customer support. We can’t imagine working without it.',
    authorName: 'Olivia Doe',
    authorPosition: 'Head of Design, Google',
  },
  {
    authorImg: TestiImage3,
    authorText:
      'Love the simplicity of the service and the prompt customer support. We can’t imagine working without it.',
    authorName: 'Olivia Doe',
    authorPosition: 'Head of Design, Google',
  },
];

// contact
export const contact = [
  {
    icon: <FiMail />,
    title: 'Have a question?',
    subtitle: 'I am here to help you.',
    description: 'Email me at ghanishtkhurana9@gmail.com',
  },
  {
    icon: <FiPhoneCall />,
    title: 'Have a nice Talk?',
    subtitle: 'I am here to talk you.',
    description: 'Contact me at +91- 9810354732',
  },
  {
    icon: <FiMapPin />,
    title: 'Current Location',
    subtitle: 'Bucharest, Romania',
    description: 'Serving clients worldwide',
  },
];
